import React, { useState, useEffect, useRef } from "react";
import { Check } from "lucide-react";

export default function AutoSaveToast({ saveStatus }) {
  const [visible, setVisible] = useState(false);
  const [fading, setFading] = useState(false);
  const prevStatusRef = useRef(saveStatus);
  const timerRef = useRef(null);

  useEffect(() => {
    const prev = prevStatusRef.current;
    prevStatusRef.current = saveStatus;

    if (prev === "saving" && saveStatus === "saved") {
      setVisible(true);
      setFading(false);

      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setFading(true);
        setTimeout(() => setVisible(false), 300);
      }, 2000);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [saveStatus]);

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 z-[80] pointer-events-none"
      style={{ transform: "translateX(-50%)" }}
    >
      <div
        className="flex items-center gap-1.5 px-4 py-2 rounded-lg bg-bookish-purple/90 text-white text-xs font-medium shadow-lg backdrop-blur-sm"
        style={{
          opacity: fading ? 0 : 1,
          transform: fading ? "translateY(8px)" : "translateY(0)",
          transition: "opacity 0.3s ease, transform 0.3s ease",
        }}
      >
        <Check size={13} />
        Browser recovery saved
      </div>
    </div>
  );
}
